
import React from 'react'
import ReactDOM from 'react-dom'
import $ from 'jquery'
import _ from 'lodash'
import {Tooltip} from 'react-bootstrap'






export default class SVHGViewDraw  {

       //sv gray theme
        BLANK = '#444444';
        ENROLL = '#8abdf8';
        PURCHASE = '#beb5e9';
        BLACKOUT = '#6d6d6d';
        MONEY = '#99cc00';
        MONEY_INFO = '#F5A623';


       //sv tundra theme
        T_BLANK = '#ffdd99';
        T_ENROLL = '#ffa500';
        T_PURCHASE = '#800000';
        T_BLACKOUT = '#80fff0';
        T_MONEY = '#40ff00';

        T_MONEY_INFO = '#995c00';

        TUNDRA_THEME = [this.T_BLANK, this.T_ENROLL, this.T_PURCHASE, this.T_BLACKOUT, this.T_MONEY, this.T_MONEY];

        GRAY_THEME = [this.BLANK, this.ENROLL, this.PURCHASE, this.BLACKOUT, this.MONEY, this.MONEY_INFO];

        SELECTED_THEME = this.GRAY_THEME;


        svOceanTheme (config){
            var gradient = false, theme;
              var themeGradient = {
                  backgroundColor: {
                      linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                      stops: [
                          [0, '#37bee7'],
                          [1, '#06005e']
                         
                      ]
                  }
            };

                  var themeOcean= {
                        backgroundColor:'#06005e'
                  };


                  var themeVenus= {
                        backgroundColor:'#fff'
                  };

                



             if(config.theme == 'OCEAN_BLUE'){
                  theme = themeOcean;

              }else if(config.theme == 'OCEAN_GRADIENT'){
                  theme = themeGradient;

              }else if(config.theme == 'SNOW_VENUS'){    

              }else{

                  theme = themeVenus;


              }

              return theme;

      };

      gcPlotMoneyValue() {

        var node = new Object();
        node.x1 = 0;
        node.y1 = 0;
        node.x2 = 0;
        node.y2 = 1;



        return node;

  };

  gcPlotMoneyRange() {


    var node = [
          [0, '#d9ccf1'],
          [1, '#6633cc']
    ];


    return node;

};
      gcTimePositions() {

        var node = [1441090800000, 1443682800000, 1446361200000, 1448956800000, 1451635200000, 1454313600000, 1456819200000

        ];


        return node;

  };
      svOceanLayer(config){

        // var gradient = false;
          var theme;

           var themeOcean= {
               layer:'#003366',
               blendInBg:'#06005e',
               size:0,
               tickLabels:{ "color": "#99ccff", "opacity":0.8, "cursor": "default", "fontSize": "10px" },
               plate:'#0066cc'

           } ;

           var themeVenus = {
                layer:'#fff',
               blendInBg:'#fff',
                 noColor:'#06005e',

               size:0,
               tickLabels:{ "color": "#99ccff", "opacity":0.8, "cursor": "default", "fontSize": "10px" },
               plate:'#fff'

           };

           if(config.theme == 'OCEAN_BLUE'){
               theme = themeOcean;

           }else if(config.theme == 'SNOW_VENUS'){
               theme = themeVenus;

           }else{

               theme = themeVenus;


           }


              
               return theme;

   };
   gcDomainMode(vector) {
         return (!vector);


   };

   getTheme() {
         return this.SELECTED_THEME;
   };


   gcDomainScaleStyleGuide() {
         var str = new Object();
         str.color = '#808080';
         str.fontFamily = 'Arial';
         str.fontSize = '12px';
         str.fontWeight = 400;
         return str;


   };
  gcDomainGuide() {
         var guide = {};
         guide.color = '#a9a9a9';
         guide.domainWidth = 1;
         guide.lineStyle = 'longDash';
         guide.nextAxis = true;
         guide.markBottomWidth = 0;
         guide.gridLineWidth = 1;
         guide.borderRadius = 6;
         guide.domainOutline = '#cccccc';

         return guide;



   };

   gcHorizontalAxis(svPositions, err, errText) {
    //svdone
    var str = new Object();
    str.categories = svPositions;
    if (err) {
          str.title = new Object();
          str.title.text = errText;
          str.title.style = new Object();

          str.title.style.color = err;
          str.title.style.fontWeight = 'bold';

    }
    return str;

};


 
gcChart() {
    //sv
    var str = new Object();

    str.type = 'area';
    // zoomType:'xy',
     str.zoomType ='xy';
    str.height = 315;
    str.borderWidth = 0;



    return str;

};


gcNavigator() {
    //sv
    var str = new Object();
    str.enabled = false;
    return str;


};
gcCredits() {
    //sv
    var str = new Object();
    str.enabled = false;
    return str;


};
gcRangeSelector() {
    //sv
    var str = new Object();
    str.enabled = false;
    return str;


};

gcLegend() {
    //sv
    var str = new Object();
    str.reverse = true;
    str.enabled = false;
    return str;


};
gcScrollbar() {
    //sv
    var str = new Object();


    str.enabled = false;



    return str;

};

    constructor(){

    }



   
}